import Vue from "vue";
import Router from "vue-router";
import union from "lodash/union";
import Home from "../components/Home.vue";
import Login from "../components/Login.vue";
import NotaPublica from "../components/notas/NotaPublica.vue";
import rutasPerfil from "../components/perfil/rutas.js";
import rutasNotas from "../components/notas/rutas.js";
import rutasGrafos from "../components/grafos/rutas.js";

Vue.use(Router);

const router = new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      name: "home",
      component: Home,
      children: union(rutasPerfil, rutasNotas, rutasGrafos),
      redirect: "/grafos",
    },
    {
      path: "/login",
      name: "login",
      component: Login,
      meta: {
        esPublica: true,
      },
    },
    {
      path: "/publica/:id",
      name: "publica",
      component: NotaPublica,
      meta: {
        esPublica: true,
      },
    },
  ],
});

router.beforeEach((to, from, next) => {
  if (to.meta.esPublica) {
    return next();
  }
  if (Vue.auth.estaAutenticado) {
    if (to.name === "login") {
      return next({ name: "home" });
    }
    return next();
  }
  if (to.name === "nota") {
    return next(to.fullPath.replace("notas/nota", "publica"));
  }
  return next({ name: "login" });
});

export default router;



// WEBPACK FOOTER //
// ./src/config/router.js